/**
 * Who may touch a «Заметка» — the client half of the backend's
 * `TextAtomPolicy` (#1836): a note belongs to its author.
 *
 * @module access/notes
 */

/** The slice of a note record the rule reads. */
export interface NoteOwnership {
    /** The atom's `author_id` (or, on a payload older than the column,
     *  `content_json.by.user_id`); `null`/absent when nobody owns it. */
    authorId?: number | null;
}

export interface NoteActor {
    userId: number | null;
    /** Whether the user may write notes at all (the content grant). */
    canAuthorNotes: boolean;
}

/**
 * Edit or delete `note`: its author alone. An ownerless note is nobody's —
 * the policy compares `author_id` with the user strictly, so `NULL` matches
 * no one. The client only decides what to offer; the server answers 403 in
 * every other case.
 */
export function canMutateNote(note: NoteOwnership, actor: NoteActor): boolean {
    if (!actor.canAuthorNotes || actor.userId === null) return false;
    return note.authorId === actor.userId;
}
